module.exports = __webpack_public_path__ + "img/calendar-wait.2765c081.svg";